module.exports = __webpack_public_path__ + "img/achievement_m.7be13f18.jpg";